import {IListener, ISubscription} from '@src/@interfaces/services/Events';

export enum SettingsKeys {
    NOTIFICATIONS_DISPLAYED = 'notifications-list-displayed',
    CHAT_FLOATING_COLLAPSED = 'floating-chat-collapsed',
    CHAT_FLOATING_CONVERSATIONS_LIST_DIALOG_OPENED = 'chat-floating-conversations-list-dialog-opened',
    CHAT_FLOATING_OPENED_DIALOGS = 'chat-floating-opened-dialogs',
    CHAT_FLOATING_PINNED_CONVERSATIONS = 'chat-floating-pinned-conversations',
}

export type KeysValues = {
    [SettingsKeys.NOTIFICATIONS_DISPLAYED]: boolean,
    [SettingsKeys.CHAT_FLOATING_COLLAPSED]: boolean,
    [SettingsKeys.CHAT_FLOATING_CONVERSATIONS_LIST_DIALOG_OPENED]: boolean,
    [SettingsKeys.CHAT_FLOATING_PINNED_CONVERSATIONS]: Array<string | number>,
    [SettingsKeys.CHAT_FLOATING_OPENED_DIALOGS]: Array<string | number>,
}

export interface ISettings {
    get<K extends SettingsKeys>(name: K): KeysValues[K] | null;

    get<V = any>(name: string): V | null;

    has(name: SettingsKeys | string): boolean;

    set<K extends SettingsKeys>(name: K, value: KeysValues[K] | null): void;

    set(name: string, value: any | null): void;

    onChanged<K extends SettingsKeys>(listener: IListener<{ name: K, value: KeysValues[K] | null }>): ISubscription;

    onChanged<V = any>(listener: IListener<{ name: string, value: V | null }>): ISubscription;

    getList(): Record<string, any>;
}
